<div data-testid="commission-by-external-travel-type-container">
  <app-generic-chart 
    [data]="data" 
    [presentationType]="presentationType"
    [chartConfiguration]="chartConfiguration">
  </app-generic-chart>
</div>